import Vue from 'vue'
import JourneyWidget from './views/JourneyWidget'
import moment from 'moment'
import VueRouter from 'vue-router'
// plugins
import { BootstrapVue } from 'bootstrap-vue'
import './styles/main.scss'

import * as VueSVGIcon from 'vue-svgicon'
import '@/components/icons'
import '@/components/logo'
import DateTime from 'vue-datetime'
// widget setup
// (optional) 'Custom elements polyfill'
import 'document-register-element/build/document-register-element'
// vue-custom-element by karol-f
import vueCustomElement from 'vue-custom-element'

import router from '@/router'
import store from './store/index'
import App from './App.vue'

const whitelabel = require('../whitelabel.config')[process.env.VUE_APP_BRAND]

Vue.use(vueCustomElement)

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueSVGIcon, {
  classPrefix: 'svg',
  isOriginalDefault: true,
  tagName: 'svg-icon',
})
Vue.use(moment)
Vue.use(DateTime)
Vue.use(VueRouter)

JourneyWidget.store = store
Vue.prototype.$whitelabel = whitelabel
// use vue-custom-element
Vue.customElement(process.env.VUE_APP_WIDGET_NAME, JourneyWidget)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#national-park-widget-documentation-page')
